import { type EmojiId, type TransferId, type TransfersResponse, TransferStatus } from '@app/client';

interface GetCurrentTransferStatusProps {
    eid: EmojiId;
    outgoingTransfers: TransfersResponse[];
}

interface CurrentTransferStatusData {
    status: TransferStatus;
    id: TransferId;
}

export function getCurrentTransferStatus({
    eid,
    outgoingTransfers,
}: GetCurrentTransferStatusProps): CurrentTransferStatusData {
    const inFlightTransfer = outgoingTransfers.find((t) => t.eid === eid);

    const data: CurrentTransferStatusData = {
        status: TransferStatus.Default,
        id: inFlightTransfer ? inFlightTransfer.id : '',
    };

    if (inFlightTransfer) {
        data.status = inFlightTransfer.accepted_at
            ? TransferStatus.Accepted
            : inFlightTransfer.sender_code_accepted_at
              ? TransferStatus.Pending
              : TransferStatus.Initiated;
    }
    if (inFlightTransfer?.deleted_at) data.status = TransferStatus.Deleted;
    return data;
}
